import { PfeilRechts } from "./Symbole";

export function Abschnitt({ titel, hinweis, kennung, children, rechts }) {
  return (
    <section className="abschnitt" id={kennung}>
      <div style={{ display: "flex", alignItems: "baseline", gap: "0.75rem" }}>
        <h2 className="abschnitt__titel" style={{ marginRight: "auto" }}>
          {titel}
        </h2>
        {rechts}
      </div>
      {hinweis && <p className="abschnitt__hinweis">{hinweis}</p>}
      {children}
    </section>
  );
}

/* Kleiner Statushinweis. Der Text trägt die Aussage, das Symbol schmückt nur. */
export function Marke({ symbol: Symbol, children, art = "" }) {
  return (
    <span className={`marke ${art ? `marke--${art}` : ""}`}>
      {Symbol && <Symbol groesse={16} />}
      {children}
    </span>
  );
}

/* Ein anklickbarer Punkt in der Liste „Was bis dahin zu tun ist“. */
export function Punkt({ symbol: Symbol, onClick, children, erledigt = false }) {
  return (
    <li>
      <button
        className={`punkt ${erledigt ? "punkt--erledigt" : ""}`}
        onClick={onClick}
        disabled={erledigt}
      >
        <span className="punkt__symbol">{Symbol && <Symbol />}</span>
        <span className="punkt__text">{children}</span>
        {!erledigt && (
          <span className="punkt__pfeil">
            <PfeilRechts groesse={18} />
          </span>
        )}
      </button>
    </li>
  );
}
